import {getPolicyCookies} from "~~/package/utils/CookieUtil";
// @ts-ignore
import mixpanel from "mixpanel-browser";
import {useUtilsStore} from "~/store/utils/utilsStore";
import {applicationContext} from "@@/package/application/applicationContext";

export const useThirdPartyRegistrationService = () => {
    const config = { public: applicationContext.getConfig() }
    const utilsStore = useUtilsStore();

    const initThirdPartyRegistrationServices = () => {
        initGoogleTagManager();
        initHotJar();
        initMSClarity();
        initMixpanel();
        utilsStore.isInitThirdPartyTools = true;
    }

    const registration = (): boolean => {
        const policyCookies = getPolicyCookies();
        if(policyCookies.performance && !utilsStore.isInitThirdPartyTools && config.public.ENVIRONMENT === 'opt') {
            if ('requestIdleCallback' in window) requestIdleCallback(initThirdPartyRegistrationServices);
            else setTimeout(initThirdPartyRegistrationServices, 3000);
        }
        return true;
    }

    const initGoogleTagManager = () => {
        // Google Tag Manager 스크립트 등록
        (function(w, d, s, l, i) {
            // @ts-ignore
            w[l] = w[l] || [];
            // @ts-ignore
            w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
            const f = d.getElementsByTagName(s)[0];
            const j = d.createElement(s);
            // @ts-ignore
            const dl = l != 'dataLayer' ? '&l=' + l : '';
            // @ts-ignore
            j.async = true;
            // @ts-ignore
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            // @ts-ignore
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-K8BBCT2H'); // GTM ID를 여기에 넣습니다.
    }

    const initHotJar = () => {
        (function(h,o,t,j,a,r){
            // @ts-ignore
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            // @ts-ignore
            h._hjSettings={hjid:3586972,hjsv:6};
            // @ts-ignore
            a=o.getElementsByTagName('head')[0];
            // @ts-ignore
            r=o.createElement('script');r.async=1;
            // @ts-ignore
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            // @ts-ignore
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    }

    const initMSClarity = () => {
        (function(c,l,a,r,i,t,y){
            // @ts-ignore
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            // @ts-ignore
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            // @ts-ignore
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "nxaj199dq3");
    }

    const initMixpanel = () => {
        mixpanel.init(config.public.MIXPANEL_TOKEN, {
            debug: true,
            track_pageview: true,
            persistence: "localStorage",
        });
    }

    return {
        registration,
    };
}
